export const NO_RECORDING_MESSAGE = 'No recording during this time.'
